import {createStrokeSVG} from './TEMPLATE'

// lucide: eye-off
export const EyeSlash_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49',
    'M14.084 14.158a3 3 0 0 1-4.242-4.242',
    'M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143',
    'm2 2 20 20',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
